export default __webpack_public_path__ + "static/photoelectric11-4ee0c4ca668b0073b759c1eea6c31d81.png";